import { useGranite } from "@/redux/modules/value/translations/translations.provider";

const Header = () => {
    const { t } = useGranite();
    return <h3>{t("search.results.title.contentPages")}</h3>;
};

export { Header };
